module.exports = __webpack_public_path__ + "img/logo.72bd8f63.jpg";